import auth from "./auth";
import story from "./story";
import banner from "./banner";
import portfolio from "./portfolio";
import adminAuth from "./admin/auth";

const handlers = [...auth, ...story, ...banner, ...portfolio, ...adminAuth];

export default handlers;
